import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choices" on a <select>
export default class extends Controller {
  static values = {
    search: { type: Boolean, default: true },
    searchThreshold: { type: Number, default: 6 },
  };

  connect() {
    document.addEventListener("turbo:before-cache", this.destroy);
    // Choices moves the select into its wrapper, which makes Stimulus reconnect this same instance
    if (this.choices) return;

    const hidden = this.element.hidden;
    this.choices = new Choices(this.element, {
      allowHTML: false,
      shouldSort: false,
      itemSelectText: "",
      removeItemButton: this.element.multiple,
      searchEnabled: this.searchValue && this.element.options.length >= this.searchThresholdValue,
      searchPlaceholderValue: "Rechercher…",
      noChoicesText: "Aucune option disponible",
      noResultsText: "Aucun résultat",
      fuseOptions: { threshold: 0.2, ignoreLocation: true },
    });
    this.element.choices = this.choices;
    this.element.closest(".choices").hidden = hidden;
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.destroy);
  }

  remove(value) {
    this.choices.removeActiveItemsByValue(value);
    this.element.form.requestSubmit();
  }

  destroy = () => {
    this.choices?.destroy();
    this.choices = this.element.choices = null;
  };
}
